export interface IMerchantProductSearch {
  id: number;
  name: string;
  key: string;
}

export const defaultMerchantProductSearch = [
  {
    id: 1,
    name: 'Product Search',
    key: 'POS Product Search'
  },
  {
    id: 2,
    name: 'Menu',
    key: 'POS Menu'
  }
]
